import { Faq } from "./components/Faq";
import TestCategory from "./components/TestCategory";
import { Dots } from "./components/svg-components/Dots";
import { Line } from "./components/svg-components/Line";
import faqData from "./Data/Faqs_subcat.json";
import { useParams } from "react-router-dom";

export const Page = () => {
  const { slug } = useParams();

  const categoryData = faqData[slug] || [];
  return (
    <>
      <section className="position-relative">
        <div className="container">
          <div className="web-container">
            <TestCategory Slug={slug} />
            <Dots className="hsection position-absolute svgwidth opacity-10 end-0 left-inherit" />
            <Line className="svgwidthline position-absolute opacity-10 top-20 start-0" />
          </div>
        </div>
      </section>
      <section id="faq" className="faq pt-5 col-12 ">
        <div className="container">
          <div className="web-container">
            <div className="row">
              <Faq className="minusbottom" slug={slug} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Page;
